import * as yup from 'yup';


export const validationSchema = yup.object({
  general: yup.object({
    'store_info/premium_plus_testimonails/is_testimonails_enabled': yup
      .string()
  }),
  first: yup.object().shape({
    'store_info/premium_plus_testimonails/first_testimonail_rating': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_first_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup
            .string()
            .nullable()
            .test(
              'store_info/premium_plus_testimonails/is_testimonails_enabled',
              'Use only numbers from 0 to 100',
              (value) => {
                if (!value) {
                  return true;
                }

                const isValueInRange = Number(value) >= 0 && Number(value) <= 100;
                return isValueInRange;
              }
            )
            .required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/first_testimonail_content': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_first_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/first_testimonail_author': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_first_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
  }),
  second: yup.object().shape({
    'store_info/premium_plus_testimonails/second_testimonail_rating': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_second_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup
            .string()
            .nullable()
            .test(
              'store_info/premium_plus_testimonails/is_second_testimonail_enabled',
              'Use only numbers from 0 to 100',
              (value) => {
                if (!value) {
                  return true;
                }

                const isValueInRange = Number(value) >= 0 && Number(value) <= 100;
                return isValueInRange;
              }
            )
            .required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/second_testimonail_content': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_second_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/second_testimonail_author': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_second_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      )
  }),
  third: yup.object().shape({
    'store_info/premium_plus_testimonails/third_testimonail_rating': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_third_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup
            .string()
            .nullable()
            .test(
              'store_info/premium_plus_testimonails/is_third_testimonail_enabled',
              'Use only numbers from 0 to 100',
              (value) => {
                if (!value) {
                  return true;
                }

                const isValueInRange = Number(value) >= 0 && Number(value) <= 100;
                return isValueInRange;
              }
            )
            .required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/third_testimonail_content': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_third_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/third_testimonail_author': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_third_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
  }),
  fourth: yup.object().shape({
    'store_info/premium_plus_testimonails/fourth_testimonail_rating': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fourth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup
            .string()
            .nullable()
            .test(
              'store_info/premium_plus_testimonails/is_fourth_testimonail_enabled',
              'Use only numbers from 0 to 100',
              (value) => {
                if (!value) {
                  return true;
                }

                const isValueInRange = Number(value) >= 0 && Number(value) <= 100;
                return isValueInRange;
              }
            )
            .required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/fourth_testimonail_content': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fourth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/fourth_testimonail_author': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fourth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
  }),
  fifth: yup.object().shape({
    'store_info/premium_plus_testimonails/fifth_testimonail_rating': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fifth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup
            .string()
            .nullable()
            .test(
              'store_info/premium_plus_testimonails/is_fifth_testimonail_enabled',
              'Use only numbers from 0 to 100',
              (value) => {
                if (!value) {
                  return true;
                }

                const isValueInRange = Number(value) >= 0 && Number(value) <= 100;
                return isValueInRange;
              }
            )
            .required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/fifth_testimonail_content': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fifth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
    'store_info/premium_plus_testimonails/fifth_testimonail_author': yup
      .string()
      .ensure()
      .when(
        'store_info/premium_plus_testimonails/is_fifth_testimonail_enabled',
        {
          is: (value) => (value == 0 ? false : value),
          then: yup.string().nullable().required('Field is required')
        }
      ),
  })
});
